import ReactDOM from 'react-dom'
import { Clusterer } from '@react-google-maps/marker-clusterer'
import { MarkerContent, Result } from './components.jsx'

addEventListener('DOMContentLoaded', () => {
    // Elements.
    const dealerblock = document.querySelector('div.dealeroverview-block')

    if (!dealerblock) return

    const form = dealerblock.querySelector('div.form-container form')
    const mapEl = dealerblock.querySelector('div.map-container #dealers-map')

    const json = JSON.parse(dealerblock.dataset.json)

    const locationField = form.querySelector('div#location input')
    const radiusField = form.querySelector('div#distance select')
    const brandField = form.querySelector('div#brand select')
    const submit = form.querySelector('input[type="submit"]')

    // Generic.
    let place = null
    let markers = []
    let startPos = null
    let markerCluster = null
    let user = {
        location: {}, marker: null, place: {}
    }

    // Load map.
    const map = new google.maps.Map(mapEl, {
        center: new google.maps.LatLng(52.0, 5.0),
        zoom: 7,
        mapTypeId: 'roadmap',
        mapTypeControlOptions: { style: google.maps.MapTypeControlStyle.DROPDOWN_MENU }
    })

    // InfoWindow & AutoComplete.
    const infoWindow = new google.maps.InfoWindow()
    const autoComplete = new google.maps.places.Autocomplete(form.querySelector('div#location input'))
    autoComplete.bindTo('bounds', map)
    autoComplete.addListener('place_changed', function () {
        if (user.marker) user.marker.setVisible(false)

        place = autoComplete.getPlace()
        if (!place.geometry) {
            window.alert('Uw locatie kon niet gevonden worden.')
            return false
        }

        user.location = place.geometry.location
        renderMarker(user.location)
    })

    submit.addEventListener('click', (event) => {
        event.preventDefault()

        var address = locationField.value
        var geocoder = new google.maps.Geocoder()
        geocoder.geocode({ address: address }, function (results, status) {
            if (status == google.maps.GeocoderStatus.OK) {
                user.location = new google.maps.LatLng(
                    parseFloat(results[0].geometry.location.lat()),
                    parseFloat(results[0].geometry.location.lng())
                )
                renderMarker(user.location)
                searchLocations()
            } else {
                alert('Uw locatie is niet bekend.')
            }
        })
    })

    // GeoSuccess -> responsible for asking user location on page load.
    var geoSuccess = function (position) {
        startPos = position

        fetch('https://maps.googleapis.com/maps/api/geocode/json', {
            method: 'GET',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ address: `${startPos.coords.latitude},${startPos.coords.longitude}`})
        }).then((response) => {
            const data = response.json()

            if (data.results && data.results.length > 0) {
                locationField.value = data.results[0].formatted_address
                user.location = new google.maps.LatLng(
                    parseFloat(startPos.coords.latitude),
                    parseFloat(startPos.coords.longitude))
                renderMarker(user.location)
            }
        })
    }
    navigator.geolocation.getCurrentPosition(geoSuccess)

    // Data.
    function searchLocations() {
        clearLocations()

        const filteredByBrand = json.filter(dealer => dealer.brands.includes(brandField.value))
        const filteredByRadius = filteredByBrand.filter((dealer) => {
            const splitted = dealer.location.split(',')
            const latLng = new google.maps.LatLng(parseFloat(splitted[0]), parseFloat(splitted[1]))

            if (latLng) {
                const distance = google.maps.geometry.spherical.computeDistanceBetween(user.location, latLng)
                dealer.distance = `${Math.round(((distance / 1000) + Number.EPSILON) * 100) / 100}km`
                return radiusField.value > (distance / 1000)
            } else {
                console.error('dealer latLng is null')
                return false
            }
        })

        if (filteredByRadius.length > 0) {
            const bounds = new google.maps.LatLngBounds()
            bounds.extend(user.location)
            filteredByRadius.forEach((d) => {
                const dealer = { ...d }
                const splitted = d.location.split(',')
                dealer.location = new google.maps.LatLng(parseFloat(splitted[0]), parseFloat(splitted[1]))
                bounds.extend(dealer.location)

                renderMarker(dealer.location, dealer)
            })
            map.fitBounds(bounds)
            markerCluster = new Clusterer(map, markers, { imagePath: '../templates/faringwell/res/images/m' })
        }
        
        renderResults(filteredByRadius)
    }

    // Render.
    function renderMarker(location, dealer = null) {
        if (dealer == null && user.marker) {
            user.marker.setMap(null)
        }

        const marker = new google.maps.Marker({
            map: map,
            position: location,
            title: !dealer ? locationField.value : `${dealer.name}, ${dealer.place}`,
            icon: icon(!dealer ? 'temp_maps_icon2' : 'temp_maps_icon1')
        })

        google.maps.event.addListener(marker, 'click', function () {
            const parent = document.createElement('div')
            ReactDOM.render(MarkerContent({ map, marker, location: locationField.value, dealer }), parent)

            infoWindow.setContent(parent)
            infoWindow.open(map, marker)
        })

        if (dealer != null) {
            markers.push(marker)
        } else {
            user.marker = marker
        }
    }

    function renderResults(dealers) {
        ReactDOM.render(Result({ dealers, location: locationField.value }), document.getElementById('results'))
    }

    // Helpers.
    function clearLocations() {
        infoWindow.close()
        markers.forEach(marker => marker.setMap(null))
        markers = []
        if (markerCluster) markerCluster.clearMarkers()

        map.setCenter(new google.maps.LatLng(52, 5))
        map.setZoom(7)
    }

    const icon = (name) => ({
        url: `../templates/faringwell/res/images/${name}.png`,
        size: new google.maps.Size(48, 70),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(17, 34),
        scaledSize: new google.maps.Size(24, 35)
    })
})